import React from 'react';

import classNames from 'classnames';

import { STATUS_OPTIONS } from './budgetOverviewFormat';

import CheckboxInput from 'CommonComponents/CheckboxInput';
import SegmentedControl from 'CommonComponents/SegmentedControl';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';

/**
 * Projects (the Organisation summary picker), Status and the committed /
 * actuals toggle. Status narrows what the table and totals show without
 * changing the selection.
 */
export default function BudgetOverviewFilters({ events, selectedCount, status, committedActuals, onOpenPicker, onChangeStatus, onChangeCommittedActuals }) {
    const pickerLabel = selectedCount === events.length && events.length > 0 ? 'All projects' : `${selectedCount} of ${events.length} projects`;

    return (
        <div className="tw-flex tw-flex-wrap tw-items-end tw-gap-x-8 tw-gap-y-4">
            <div>
                <div className="tw-text-sm tw-text-blue-75 tw-font-medium tw-mb-2">Projects</div>
                <button
                    type="button"
                    onClick={onOpenPicker}
                    className={classNames(
                        'tw-flex tw-items-center tw-justify-between tw-gap-2 tw-min-w-[200px]',
                        'tw-border-2 tw-border-grey tw-rounded-lg tw-text-sm tw-px-3 tw-py-1.5 tw-bg-white',
                    )}
                >
                    <span className="tw-text-charcoal">{pickerLabel}</span>
                    <ChevronDownIcon className="tw-w-3 tw-h-3" />
                </button>
            </div>

            <div>
                <span id="budget_overview_status_label" className="tw-block tw-text-sm tw-text-blue-75 tw-font-medium tw-mb-2">
                    Status
                </span>
                <div aria-labelledby="budget_overview_status_label">
                    <SegmentedControl variant="track" options={STATUS_OPTIONS} value={status} onChange={onChangeStatus} />
                </div>
            </div>

            <div className="tw-pb-1.5 tw-text-sm tw-text-charcoal">
                <CheckboxInput
                    label="Include committed and actuals to date"
                    checked={committedActuals}
                    onChange={(event) => onChangeCommittedActuals(event.target.checked)}
                />
            </div>
        </div>
    );
}
